import MapStyle from '@/assets/json/gmaps-style.json'

const state = {
  startMapZoom: 17,
  minMapZoom: 14,
  maxMapZoom: 20,
  googleDeafultIcons: MapStyle,
  filters: {
    schools: false,
    transport: false,
    leisure: false,
    green_areas: false,
    food_and_drink: false
  }
}

const mutations = {
  plusZoomLevel (state) {
    if (state.startMapZoom >= state.maxMapZoom) {
    } else {
      state.startMapZoom = parseInt(state.startMapZoom) + 1
    }
  },
  minusZoomLevel (state) {
    if (state.startMapZoom <= state.minMapZoom) {
    } else {
      state.startMapZoom = parseInt(state.startMapZoom) - 1
    }
  },
  setStartMapZoom (state, payload) {
    state.startMapZoom = payload
  },
  setGoogleArray (state, payload) {
    state.googleDeafultIcons.push(payload)
  },
  removeFromGoogleArray (state, payload) {
    for (let i = 0; i < state.googleDeafultIcons.length; i++) {
      if (payload === state.googleDeafultIcons[i].featureType) {
        var removeIndex = state.googleDeafultIcons.map(function (item) { return item.featureType }).indexOf(payload)
        state.googleDeafultIcons.splice(removeIndex, 1)
      }
    }
  },
  setMapZoom (state, payload) {
    state.startMapZoom = payload
  },
  setSchoolFilter (state, payload) {
    state.filters.schools = payload
  },
  setTransportFilter (state, payload) {
    state.filters.transport = payload
  },
  setLeisureFilter (state, payload) {
    state.filters.leisure = payload
  },
  setGreenAreasFilter (state, payload) {
    state.filters.green_areas = payload
  },
  setFoodAndDrinkFilter (state, payload) {
    state.filters.food_and_drink = payload
  }
}

export default {
  state,
  mutations
}
